<template>
	<div>
        <div class="row">
            <div class="col-md-12 mb-2">
				<h4>DO OUTSTANDING REPORT</h4>
			</div>

            <div class="col-md-12 mb-2">
                <el-card class="box-card col-md-12 mb-0" shadow="never" :body-style="{ paddingLeft: '6px', paddingRight: '6px', paddingTop: '10px', paddingBottom: '16px' }">
                    <DOOutstandingDetailReport :tabIndex="'0'" :tabName="'detail'" :tabLabel="'Detail'" :showTitle="true"/>
                </el-card>
            </div>

			<div class="col-md-12" v-if="false">
                <el-card class="box-card col-md-12 mb-4" shadow="hover">
                    <div slot="header" class="clearfix">
                        <h4>DO OUTSTANDING REPORT</h4>
                    </div>
                    <div style="margin:0px -20px;">
                        <el-tabs type="border-card" v-model="tabIndex" @tab-click="handleTabClick">
                            <el-tab-pane :label="'Detail'" :name="'0'">
                                <DOOutstandingDetailReport :tabIndex="'0'" :tabName="'detail'" :tabLabel="'Detail'"/>
                            </el-tab-pane>

                        </el-tabs>

                    </div>

                </el-card>
            </div>
        </div>
    </div>
</template>


<script>
import Finance from '@/components/page/Finance.js'
import { Rainbow, Rainbow3, Config, AxiosWithJar, Penanggalan } from '@/utility.js'
import DOOutstandingDetailReport from '@/views/pages/Fuel/DOOutstanding/Report/ReportDetail.vue'


export default
{
	extends: Finance,
	components: { 
        DOOutstandingDetailReport,
	},

	data(){
		return {
            tabIndex : '0',
            urlRequestParams: '',
            reportdata: [],
            stationid: '',
            plant: '',
            spbu: {
                list:[],
            },
			options: {

            },
            loading: {
                table: false,
                isSuccess: false,
            },
            date: { 
				Start: this.$route.query.dateStart ? this.$route.query.dateStart : Penanggalan().tahunSekarang,
				End: this.$route.query.dateEnd ? this.$route.query.dateEnd : Penanggalan().kemarin, 
			},
            dateRange: [this.$route.query.dateStart ? this.$route.query.dateStart : Penanggalan().tahunSekarang,this.$route.query.dateEnd ? this.$route.query.dateEnd : Penanggalan().kemarin], 
            pickerOptions: {
				shortcuts: [{
					text: 'Last week',
					onClick(picker) {
					const end = new Date();
					const start = new Date();
					start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
					picker.$emit('pick', [start, end]);
					}
				}, {
					text: 'Last month',
					onClick(picker) {
					const end = new Date();
					const start = new Date();
					start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
					picker.$emit('pick', [start, end]);
					}
				}, {
					text: 'Last 3 months',
					onClick(picker) {
					const end = new Date();
					const start = new Date();
					start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
					picker.$emit('pick', [start, end]);
					}
				}]
			},
        }
    },

    watch: {

    }, 

    computed: {
        
    },

    mounted() {
        this.$emit('childrenRoute');
        this.loadStationList()
    },

    methods: { 
        async loadStationList(type='') {
			this.urlRequestParams = Config().apiURL
            this.urlRequestParams += "/fuel2/station?"  + (type ? "&type=" + type : "") + (this.plant ? "&plant=" + this.plant : "") + (this.stationid ? "&station=" + this.stationid : "");
			await AxiosWithJar().get(this.urlRequestParams).then(result=>{
				if(result.data.data.length){
					this.spbu.list = result.data.data;
				}
			})
		},

        handleTabClick(tab, event) {
            let tabIndex = tab.$vnode.key
            let tabName = tab.name
            let tabLabel = tab.label

            this.tab.index = tabIndex
            this.tab.name = tabName
            this.tab.label = tabLabel
        },

    }
        
}

</script>